function required(name: string, value: string | undefined): string {
  if (value === undefined || value === '') {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
}

export const SERVICE_BASEURL: string = required('SERVICE_BASEURL', process.env.SERVICE_BASEURL);
export const ASSET_BASEURL: string = required('ASSET_BASEURL', process.env.ASSET_BASEURL);
export const MEDIA_BASEURL: string = required('SERVICE_URL', process.env.MEDIA_BASEURL);
export const AUTH0_DOMAIN: string = required('AUTH0_DOMAIN', process.env.AUTH0_DOMAIN);
export const AUTH0_AUDIENCE: string = required('AUTH0_AUDIENCE', process.env.AUTH0_AUDIENCE);
export const AUTH0_CLIENTID: string = required('AUTH0_CLIENTID', process.env.AUTH0_CLIENTID);
export const AUTH0_SCOPE: string = 'openid profile';
export const DEFAULT_CHARITYLOGOIMAGEURL: string =
  MEDIA_BASEURL + required('DEFAULT_CHARITYLOGOIMAGEURL', process.env.DEFAULT_CHARITYLOGOIMAGEURL);
export const DEFAULT_CHARITYVERTICALIMAGEURL: string =
  MEDIA_BASEURL +
  required('DEFAULT_CHARITYVERTICALIMAGEURL', process.env.DEFAULT_CHARITYVERTICALIMAGEURL);
export const DEFAULT_CHARITYHORIZONTALIMAGEURL: string =
  MEDIA_BASEURL +
  required('DEFAULT_CHARITYHORIZONTALIMAGEURL', process.env.DEFAULT_CHARITYHORIZONTALIMAGEURL);
export const DEFAULT_INITIATIVEVERTICALIMAGEURL: string =
  MEDIA_BASEURL +
  required('DEFAULT_INITIATIVEVERTICALIMAGEURL', process.env.DEFAULT_INITIATIVEVERTICALIMAGEURL);
export const DEFAULT_INITIATIVEHORIZONTALIMAGEURL: string =
  MEDIA_BASEURL +
  required(
    'DEFAULT_INITIATIVEHORIZONTALIMAGEURL',
    process.env.DEFAULT_INITIATIVEHORIZONTALIMAGEURL,
  );
export const PAYPAL_CLIENTID: string = required('PAYPAL_CLIENTID', process.env.PAYPAL_CLIENTID);
export const TIP_CHARITYID: string = required('TIP_CHARITYID', process.env.TIP_CHARITYID);
export const TIP_INITIATIVEID: string = required('TIP_INITIATIVEID', process.env.TIP_INITIATIVEID);
export const MATCH_SINGLE_IMAGE: string =
  MEDIA_BASEURL + required('MATCH_SINGLE_IMAGE', process.env.MATCH_SINGLE_IMAGE);
export const MATCH_DOUBLE_IMAGE: string =
  MEDIA_BASEURL + required('MATCH_DOUBLE_IMAGE', process.env.MATCH_DOUBLE_IMAGE);

export const MATCH_SINGLE_WHITE_IMAGE: string =
  MEDIA_BASEURL + required('MATCH_SINGLE_WHITE_IMAGE', process.env.MATCH_SINGLE_WHITE_IMAGE);
export const MATCH_DOUBLE_WHITE_IMAGE: string =
  MEDIA_BASEURL + required('MATCH_DOUBLE_WHITE_IMAGE', process.env.MATCH_DOUBLE_WHITE_IMAGE);

export const BLOB_URL: string = 'https://dd.local.nthversion.com/wp-content/uploads/2025/05';

export const ALERT_TYPE_ERROR: string = 'Error';
export const ALERT_TYPE_SUCCESS: string = 'Success';

export const URL_MYACCOUNT: string = '/myaccount';
export const URL_MANAGECHARITY: string = '/managecharity';
export const URL_MANAGEINITIATIVE: string = '/manageinitiative';
export const URL_CHARITY: string = '/charity';
export const URL_INITIATIVE: string = '/initiative';
export const URL_CAUSES: string = '/causes';
export const URL_CAUSE: string = '/cause';
export const URL_MANAGECLAIM: string = '/claim';
export const URL_CHECKOUT: string = '/donate';
export const URL_SEARCH: string = '/searchprograms';
export const URL_RECEIPT: string = '/receipt';
export const URL_TERMS: string = '/terms';
export const URL_NONPROFITINVITE: string = '/nonprofitinvite';

export const QUERYPARAMETER_CAUSEID: string = 'causeid';
export const QUERYPARAMETER_CLAIMCODE: string = 'claimCode';
export const QUERYPARAMETER_CHARITYID: string = 'charityid';
export const QUERYPARAMETER_INITIATIVEID: string = 'initiativeid';
export const QUERYPARAMETER_PAYMENTID: string = 'paymentid';
export const QUERYPARAMETER_SEARCH_QUERY: string = 'query';

export const STORAGE_DONATIONS: string = 'cbf_donations';

export const CATEGORY_SEARCH_TYPE_CHARITY: string = 'Charity';
export const CATEGORY_SEARCH_TYPE_INITIATIVE: string = 'Initiative';

export const DONATION_TYPE_CHARITY: string = 'charity';
export const DONATION_TYPE_INITIATIVE: string = 'initiative';
export const DONATION_TYPE_AREA_SHELTER: string = 'shelter';
export const DONATION_TYPE_AREA_MEDIASTATION: string = 'mediastation';
export const DONATION_TYPE_AREA_FOODBANK: string = 'foodbank';
export const DONATION_TYPE_TIP: string = 'tip';
export const DONATION_TYPE_CREDIT: string = 'credit';

export const FEE_PAYPAL_PERCENT_BPS: number = 199;
export const FEE_PAYPAL_FIXED: number = 49;
export const FEE_BILLCOM_PERCENT: number = 0;
export const FEE_BILLCOM_FIXED: number = 59;
export const MAX_MATCH_AMOUNT: number = 100000;
